import { sendApiClientRequest } from "../../api/api";

const BASE = "/api/center/activities";
const HIGHLIGHTS_BASE = "/api/center/activity-highlights";

const unwrap = (res) => {
  if (!res || res.status >= 400) {
    const msg = res?.data?.msg ?? "請求失敗";
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  const body = res.data;
  if (!body || typeof body !== "object") {
    return null;
  }
  if (body.error) {
    const msg = body.msg ?? "錯誤";
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  return body.data !== undefined ? body.data : null;
};

export const fetchActivitiesList = async ({ search = "", page = 1, limit = 10 }) => {
  const params = new URLSearchParams();
  if (search.trim()) {
    params.set("search", search.trim());
  }
  params.set("page", String(page));
  params.set("limit", String(limit));
  const res = await sendApiClientRequest("GET", `${BASE}?${params.toString()}`);
  return unwrap(res);
};

export const fetchActivityById = async (id) => {
  const res = await sendApiClientRequest("GET", `${BASE}/${id}`);
  return unwrap(res);
};

export const createActivity = async (payload) => {
  const res = await sendApiClientRequest("POST", BASE, payload);
  return unwrap(res);
};

export const updateActivity = async (id, payload) => {
  const res = await sendApiClientRequest("PATCH", `${BASE}/${id}`, payload);
  return unwrap(res);
};

export const deleteActivity = async (id) => {
  const res = await sendApiClientRequest("DELETE", `${BASE}/${id}`);
  return unwrap(res);
};

export const publishActivity = async (id) => {
  const res = await sendApiClientRequest("POST", `${BASE}/${id}/publish`);
  return unwrap(res);
};

export const unpublishActivity = async (id) => {
  const res = await sendApiClientRequest("POST", `${BASE}/${id}/unpublish`);
  return unwrap(res);
};

export const fetchActivityRegistrations = async (
  activityId,
  { search = "", page = 1, limit = 10 } = {},
) => {
  const params = new URLSearchParams();
  if (search.trim()) {
    params.set("search", search.trim());
  }
  params.set("page", String(page));
  params.set("limit", String(limit));
  const res = await sendApiClientRequest(
    "GET",
    `${BASE}/${activityId}/registrations?${params.toString()}`,
  );
  return unwrap(res);
};

export const fetchRegistrationsList = async ({
  search = "",
  status = "",
  activityId = "",
  page = 1,
  limit = 10,
} = {}) => {
  const params = new URLSearchParams();
  if (search.trim()) {
    params.set("search", search.trim());
  }
  if (status.trim()) {
    params.set("status", status.trim());
  }
  if (activityId !== "" && activityId != null) {
    params.set("activity_id", String(activityId));
  }
  params.set("page", String(page));
  params.set("limit", String(limit));
  const res = await sendApiClientRequest(
    "GET",
    `/api/center/registrations?${params.toString()}`,
  );
  return unwrap(res);
};

export const fetchRegistrationsByEmailActivities = async ({
  email,
  page = 1,
  limit = 200,
} = {}) => {
  const params = new URLSearchParams();
  if (email != null && String(email).trim()) {
    params.set("email", String(email).trim());
  }
  params.set("page", String(page));
  params.set("limit", String(limit));
  const res = await sendApiClientRequest(
    "GET",
    `/api/center/registrations/by-email/activities?${params.toString()}`,
  );
  return unwrap(res);
};

export const exportActivityRegistrationsCsv = async (
  activityId,
  { search = "", status = "" } = {},
) => {
  const params = new URLSearchParams();
  if (search.trim()) {
    params.set("search", search.trim());
  }
  if (status.trim()) {
    params.set("status", status.trim());
  }
  const res = await sendApiClientRequest(
    "GET",
    `${BASE}/${activityId}/registrations/export?${params.toString()}`,
    undefined,
    false,
    "blob",
  );
  if (!res || res.status >= 400) {
    const msg = res?.data?.msg ?? "匯出失敗";
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  return res;
};

export const exportCenterRegistrationsCsv = async ({ search = "" } = {}) => {
  const params = new URLSearchParams();
  if (search.trim()) {
    params.set("search", search.trim());
  }
  const qs = params.toString();
  const res = await sendApiClientRequest(
    "GET",
    `/api/center/registrations/export${qs ? `?${qs}` : ""}`,
    undefined,
    false,
    "blob",
  );
  if (!res || res.status >= 400) {
    const msg = res?.data?.msg ?? "匯出失敗";
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  return res;
};

export const fetchActivityHighlightsList = async ({
  search = "",
  page = 1,
  limit = 10,
} = {}) => {
  const params = new URLSearchParams();
  if (search.trim()) {
    params.set("search", search.trim());
  }
  params.set("page", String(page));
  params.set("limit", String(limit));
  const res = await sendApiClientRequest(
    "GET",
    `${HIGHLIGHTS_BASE}?${params.toString()}`,
  );
  return unwrap(res);
};

export const fetchActivityHighlightById = async (id) => {
  const res = await sendApiClientRequest("GET", `${HIGHLIGHTS_BASE}/${id}`);
  return unwrap(res);
};

export const createActivityHighlight = async (payload) => {
  const res = await sendApiClientRequest("POST", HIGHLIGHTS_BASE, payload);
  return unwrap(res);
};

export const updateActivityHighlight = async (id, payload) => {
  const res = await sendApiClientRequest("PATCH", `${HIGHLIGHTS_BASE}/${id}`, payload);
  return unwrap(res);
};

export const pinActivityHighlight = async (id) => {
  const res = await sendApiClientRequest("POST", `${HIGHLIGHTS_BASE}/${id}/pin`);
  return unwrap(res);
};

export const deleteActivityHighlight = async (id) => {
  const res = await sendApiClientRequest("DELETE", `${HIGHLIGHTS_BASE}/${id}`);
  return unwrap(res);
};
